export default "__VITE_ASSET__BkAQah8U__"